import { render, staticRenderFns } from "./PerformanceUpload.vue?vue&type=template&id=63409df4&scoped=true"
import script from "./PerformanceUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceUpload.vue?vue&type=script&setup=true&lang=js"
import style1 from "./PerformanceUpload.vue?vue&type=style&index=1&id=63409df4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63409df4",
  null
  
)

export default component.exports